// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-device-app-version-upload-summary-deviceAppVersionUploadSummary-module__container-PMn4Fo","labelWrapper":"src-domain-components-device-app-version-upload-summary-deviceAppVersionUploadSummary-module__labelWrapper-DKmzvD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-device-app-version-upload-summary-deviceAppVersionUploadSummary-module__container-PMn4Fo\",\"labelWrapper\":\"src-domain-components-device-app-version-upload-summary-deviceAppVersionUploadSummary-module__labelWrapper-DKmzvD\"}";
        // 1793705033147
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  